/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_No_WaypointsInputs */

const en_dispatch_no_waypoints = /** @type {(inputs: Dispatch_No_WaypointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building_map unavailable`)
};

const fr_dispatch_no_waypoints = /** @type {(inputs: Dispatch_No_WaypointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building_map indisponible`)
};

const ms_sg2_dispatch_no_waypoints = /** @type {(inputs: Dispatch_No_WaypointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building_map tidak tersedia`)
};

/**
* | output |
* | --- |
* | "Building_map unavailable" |
*
* @param {Dispatch_No_WaypointsInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_no_waypoints = /** @type {((inputs?: Dispatch_No_WaypointsInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_No_WaypointsInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_no_waypoints(inputs)
	if (locale === "fr") return fr_dispatch_no_waypoints(inputs)
	return ms_sg2_dispatch_no_waypoints(inputs)
});